import ElakayImage from '../../components/images/ElakayImage';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { toImageUrl } from '../../config';
import useElakaySwiper from '../slider/swiperSettings/useElakaySwiper';
import { getPublicImageFiles } from './apiSwiperImageFiles';
import { selectImages } from './imageSelection';

// Image-only fallback. The enclosing CategoryAdBanner resolves published
// category placements first; its own image advertisements also take priority.
const DefaultCategorySwiper = ({ categoryId, children, swiperOptions }) => {
  const [visibleIndex, setVisibleIndex] = useState(0);
  const [selection, setSelection] = useState(null);
  useEffect(() => {
    let cancelled = false;
    setSelection(null);
    getPublicImageFiles('categories').then((data) => {
      if (!cancelled) setSelection({ ...data, images: selectImages(data.images || [], Math.min(4, data.settings?.slideCount || 4), `elakay-category-images:${categoryId}`) });
    });
    return () => { cancelled = true; };
  }, [categoryId]);
  const images = selection?.images || [];
  const options = {};
  ['desktop', 'tablet', 'mobile'].forEach((device) => {
    const own = swiperOptions?.[device] || {};
    const saved = selection?.settings?.swiperOptions?.[device] || {};
    options[device] = { ...saved };
    Object.keys(own).forEach((group) => { options[device][group] = { ...saved[group], ...own[group] }; });
  });
  const managed = useElakaySwiper('promoBanner', { swiperOptions: options, slideCount: images.length });
  if (!images.length) return children;
  return <section aria-label="Category promotions" style={{ aspectRatio: '12 / 5', overflow: 'hidden' }}>
    <Swiper onSlideChange={(swiper) => setVisibleIndex(swiper.realIndex)} key={managed.key} {...managed.swiperProps} className={managed.className} style={{ ...managed.style, height: '100%' }}>
      {images.map((image, index) => <SwiperSlide key={image.id}>
        {index === visibleIndex && <ElakayImage preset="banner" src={toImageUrl(image.url)} alt={image.alt || image.name} loading={index === 0 ? 'eager' : 'lazy'} decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
      </SwiperSlide>)}
    </Swiper>
  </section>;
};
export default DefaultCategorySwiper;
